import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { filter, map, startWith } from 'rxjs';

@Component({
    selector: 'app-configurator-3d-btn',
    templateUrl: './configurator-3d-btn.component.html',
    styleUrls: ['./configurator-3d-btn.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, RouterLink, TranslateModule],
})
export class Configurator3DButtonComponent {
    private router = inject(Router);

    readonly disabled$ = this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd),
        startWith(this.router.routerState.snapshot),
        map((data) => data.url.startsWith('/orders/new/special') && data.url.endsWith('build')),
    );
}
